<template>
    <v-container fluid grid-list-md>
        <v-layout column wrap>
            <v-flex>
                <h1 class="display-3">Gestión de descuentos</h1>
                <br>
                <v-card>
                    <v-card-text>
                        <form @submit.prevent="agregar()" ref="form" lazy-validation>
                            <v-layout>
                                <v-flex xs12 sm2>
                                    <v-text-field label="Presupuesto" v-model="d.presupuesto_id"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <v-text-field label="Descuento" v-model="d.descuento"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <v-text-field label="Fact ocup paneles" v-model="d.fact_ocp_pan"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <v-text-field label="Fact ocup equipos" v-model="d.fact_ocp_equ"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <v-text-field label="Fact ocup camaras" v-model="d.fact_ocp_cam"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex>
                                    <v-btn type="submit" dark color="green" :loading="loading">
                                        Agregar
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-data-table
                        :headers="headers"
                        :items="items"
                        :pagination.sync="pag"
                        :total-items="totalItems"
                        :loading="loading"
                        rows-per-page-text="Filas por pagina"
                        no-data-text="No hay datos"
                        disable-initial-sort
                        item-key="id"
                        class="tabla-compacta-col"
                >
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-center">
                            {{ props.item.presupuesto_id }}
                        </td>
                        <td class="text-xs-center">
                            <v-edit-dialog
                                    save-text="Guardar"
                                    cancel-text="Cancelar"
                                    large
                                    lazy
                                    style="width: 100%"
                                    @save="editar(props.index,props.item)">
                                <span style="width: 100%">{{ (props.item.fact_ocp_pan)?props.item.fact_ocp_pan : 0 | moneda }}</span>
                                <v-text-field
                                        slot="input"
                                        v-model="n.fact_ocp_pan"
                                        label="Editar"
                                        single-line
                                        type="number"
                                        hint="Presione <kbd>enter</kbd> para guardar"
                                >
                                </v-text-field>
                            </v-edit-dialog>
                        </td>
                        <td class="text-xs-center">
                            <v-edit-dialog
                                    save-text="Guardar"
                                    cancel-text="Cancelar"
                                    large
                                    lazy
                                    style="width: 100%"
                                    @save="editar(props.index,props.item)">
                                <span style="width: 100%">{{ (props.item.fact_ocp_equ)?props.item.fact_ocp_equ : 0 | moneda }}</span>
                                <v-text-field
                                        slot="input"
                                        v-model="n.fact_ocp_equ"
                                        label="Editar"
                                        single-line
                                        type="number"
                                        hint="Presione <kbd>enter</kbd> para guardar"
                                >
                                </v-text-field>
                            </v-edit-dialog>
                        </td>
                        <td class="text-xs-center">
                            <v-edit-dialog
                                    save-text="Guardar"
                                    cancel-text="Cancelar"
                                    large
                                    lazy
                                    style="width: 100%"
                                    @save="editar(props.index,props.item)">
                                <span style="width: 100%">{{ (props.item.fact_ocp_cam)?props.item.fact_ocp_cam : 0 | moneda }}</span>
                                <v-text-field
                                        slot="input"
                                        v-model="n.fact_ocp_cam"
                                        label="Editar"
                                        single-line
                                        type="number"
                                        hint="Presione <kbd>enter</kbd> para guardar"
                                >
                                </v-text-field>
                            </v-edit-dialog>
                        </td>
                        <td class="text-xs-center">
                            <v-edit-dialog
                                    save-text="Guardar"
                                    cancel-text="Cancelar"
                                    large
                                    lazy
                                    style="width: 100%"
                                    @save="editar(props.index,props.item)">
                                <span style="width: 100%">{{ (props.item.descuento)?props.item.descuento : 0 | moneda }}</span>
                                <v-text-field
                                        slot="input"
                                        v-model="n.descuento"
                                        label="Editar"
                                        single-line
                                        type="number"
                                        hint="Presione <kbd>enter</kbd> para guardar"
                                >
                                </v-text-field>
                            </v-edit-dialog>
                        </td>
                        <td class="text-xs-center">
                            <v-btn flat icon @click.native="eliminar(props.item.id)" color="red"
                                   :loading="loadingDel === props.item.id">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import fleteMixin from '../../mixins/flete_descuento';
    import moneda from '../../filters/moneda';
    import {mapActions} from 'vuex';

    function initialValue() {
        return {
            descuento: '',
            fact_ocp_pan: '',
            fact_ocp_cam: '',
            fact_ocp_equ: '',
            presupuesto_id: '',
        }
    }

    export default {
        name: "flete_descuento",
        mixins: [fleteMixin],
        filters: {moneda},
        data() {
            return {
                loading: false,
                loadingDel: -1,
                d: initialValue(),
                n: initialValue(),
                precioNuevo: 0,
                headers: [
                    {text: 'Presupuesto', value: 'presupuesto_id', align: 'center'},
                    {text: 'Fact ocup pan', value: 'fact_ocp_pan', align: 'center'},
                    {text: 'Fact ocup equ', value: 'fact_ocp_equ', align: 'center'},
                    {text: 'Fact ocup cam', value: 'fact_ocp_cam', align: 'center'},
                    {text: 'Descuento', value: 'descuento', align: 'center'},
                    {text: 'Opciones', value: '', align: 'center', sortable: false},
                ],
                items: [],
                pag: {},
                totalItems: 0,
            }
        },
        watch: {
            pag: {
                handler() {
                    this.tabla();
                },
                deep: true
            }
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            tabla() {
                this.loading = true;
                this.fleteDescuentoIndex(this.pag, r => {
                    this.totalItems = r.total;
                    this.items = r.data;
                    this.loading = false;
                }, err => {
                    console.log(err);
                    this.loading = false;
                });
            },
            agregar() {
                this.loading = true;
                this.fleteDescuentoStore(this.d, r => {
                    this.msjShow(r);
                    this.tabla();
                    this.d = initialValue();
                    this.loading = false;
                }, err => {
                    this.msjShow({txt: 'Error al guardar', tipo: 'error'});
                    this.loading = false;
                });
            },
            editar(index, item) {
                this.loading = true;
                this.fleteDescuentoUpdate(item.id, this.n, r => {
                    this.msjShow(r);
                    this.items[index] = r.r;
                    this.n = initialValue();
                    this.loading = false;
                }, err => {
                    console.error('Error');
                    this.loading = false;
                });
                return false;
            },
            eliminar(id) {
                this.loadingDel = id;
                this.fleteDescuentoDestroy(id, r => {
                    this.msjShow(r);
                    this.tabla();
                    this.loadingDel = -1;
                }, err => {
                    this.msjShow({txt: 'Error al eliminar', tipo: 'error'});
                    this.loadingDel = -1;
                });
            },
        }
    }
</script>

<style>
    .v-menu__activator a {
        width: 100% !important;
        text-align: right !important;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/flete/descuento.vue